<!--
  ナビゲーターの上部です
  ダッシュボード＆ホーム
-->
<template>
<div class="pa-0">
  <v-app-bar
    app
    color="white"
    clipped-left
    class="pl-0 head"
    height="60px"
    width="100%"
  >
    <!--ベースタイトル-->
    <div
      class="ma-0"
      style="background-color: #294a66; height: 100px; width: 80px"
      v-if="unfold"
    ></div>
    <div
      class="ma-0"
      style="background-color: #294a66; height: 100px; width: 312px"
      v-else
    ></div>

    <!--ページタイトル-->
    <div class="d-flex align-center title mplus-2c-bold ml-4">
      <h3>{{ pageTitle }}</h3>
    </div>
    <v-spacer></v-spacer>

    <!--プロフィール用アカウント画像-->
    <v-btn
      text
      class="pl-5"
      height="100px"
      data-testid="gotosettings"
      @click="openPro()"
    >
      <v-img
        v-if="profImageS"
        width="50px"
        height="50px"
        class="preview-item-file rounded-circle"
        :src="profImageS"
        alt=""
      ></v-img>
      <v-img
        v-else
        src="../../assets/svg/プロフィールアイコン.svg"
        alt=""
        width="50px"
      ></v-img>
    </v-btn>
    <!--通知ボタン-->
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          @click="$store.dispatch('setNotifyRead')"
          icon
        >
        <v-badge
          :content="notify_nums"
          :value="notify_nums>0"
          color="deepLava"
          overlap
        >
          <v-icon size="55px">mdi-bell-circle</v-icon>
        </v-badge>
        </v-btn>
      </template>
      <notifyList
        @openModal="openDetailNotification"
      ></notifyList>
    </v-menu>
  </v-app-bar>
  <!--通知詳細画面-->
  <v-dialog v-model="detailNotification" width="90%" height="80%">
    <notifyDetail @closeModal="closeDetailNotification()" :sort="sort"></notifyDetail>
  </v-dialog>
  <!--プロフィール画面-->
  <profile_display
    :profile="profile"
    :profuid="uid"
    device="pc"
    @closeProfile="closeProfile"
  ></profile_display>
  <!--サインイン画面-->
  <v-dialog v-model="authModal" width="400px" height="60%">
    <auth-view
      v-if="authModal"
      defaultView="chooseauth"
      @closeModal="closeAuthModal"
    >
    </auth-view>
  </v-dialog>
</div>
</template>
<script>
import notifyDetail from '../notifyDetail.vue'
import firebase from "firebase";
import profile_display from "./../profile/profile_display.vue";
import authView from '../auth/authView.vue';
import notifyList from '../notifyList.vue'
export default {
  props: {
    pageTitle: String,
    uid: String,
    profImageS: String,
    unfold: Boolean
  },
  components: {
    profile_display,
    authView,
    notifyList,
    notifyDetail
  },
  computed:{
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    members(){
      return this.$store.state.members
    },
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin() {
      return this.$store.state.isAdmin
    },
    notify_nums(){
      return this.$store.state.notify_nums
    },
  },
  data() {
    return {
      profile: false,
      notifyId: "",
      authModal: false,
      detailNotification: false,
      menu: false,
      todayy: "",
      sort:""
    };
  },
  methods: {
    /*
      プロフィール画面(profile_display)を閉じる関数
      コンポーネントから呼び出し
    */
    openPro(){
      if(this.isAuthed){
        this.profile = true
        this.appbarpro = true        
      }
      else{
        this.authModal = true
      }
    },
    closeProfile() {
      this.profile = false;
    },
    toDoubleDigits(num) {
        num += "";
        if (num.length === 1) {
          num = "0" + num;
        }
      return num; 
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayy = yyyy + mm + dd + hh + mi + se + ms
    },
    checkNotify(type){
      this.$router.push("/home")
    },
    closeAuthModal() {
      this.authModal = false
    },
    openDetailNotification(el){
      this.sort = el
      this.detailNotification = true
    },
    closeDetailNotification(){
      this.detailNotification = false
    },
  },
};
</script>
<style scoped>
.head >>> .v-toolbar__content {
  padding-left: 0px !important;
  z-index: 10;
}
.step{
  list-style-type: none;
  display:table;
  width:100%;
  padding:0;
  margin:0;
  overflow:hidden;
}
.step li{
  display:table-cell;
  width:10%;
  position:relative;
  background: #DCDCDC;
  padding: 1em 0.5em 1em 2em;
  color: #707070;
}
.step li:last-child{
  padding-right: 1em;
}
.step li:last-child:before,
.step li:last-child:after{
  display:none;
}
.step li:before,
.step li:after{
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  margin: auto;
}
.step li:before{
  top:-15px;
  right:-1em;
  border-style: solid;
  border-color: transparent transparent transparent #fff;
  border-width: 40px 0 40px 1em;
  z-index: 5;
}
.step li:after{
  top:-15px;
  right:-.8em;
  border-style: solid;
  border-color: transparent transparent transparent #DCDCDC;
  border-width: 40px 0 40px 1em;
  z-index: 5;
}
.step li.current{
  background: #fff;
  color: #2B2B2B;
  font-weight: bold;
}
.step li.current:after{
  border-color: transparent transparent transparent #fff;
}
.headher {
  position: sticky;
  top: 0;
  z-index: 5;
  background: white;
}
</style>